// keep these values in sync with those in /src/theme.scss
export const screenSizes = {
    mobile: 768,
    desktop: 1024,
    largeDesktop: 1440,
};
